import { useTranslation } from 'react-i18next';
import { FormModal } from 'pages/global/FormModal';
import { Button, Modal } from 'react-bootstrap';
import { CopyToClipboard } from 'components/CopyToClipboard';
import { getEnv } from 'config/Env';
import { useGetAreaId } from 'pages/documents_v2/views/edit_area/hooks/useGetAreaId';
import { useMemo } from 'react';
import { useGetDocumentId } from 'pages/documents_v2/views/edit_area/hooks/useGetDocumentId';
import queryString from 'query-string';
import { ROUTES } from 'config/routes';
import { useGetArea } from 'pages/documents_v2/hooks/useGetArea';
import { generatePath } from 'react-router-dom';
import HelperFunctions from 'pages/global/HelperFunctions';
import _ from 'lodash';

export function ShareModal({ block = undefined, handleClose }) {
    const { t } = useTranslation();
    const publicUrl = getEnv('PUBLIC_URL');
    const documentId = useGetDocumentId();
    const areaId = useGetAreaId();
    const area = useGetArea(areaId);

    const url = useMemo(() => {
        const params = {
            t: area.title,
            d: documentId,
            a: areaId,
            b: block?.id,
        };

        const path = generatePath(ROUTES.public.share, {
            slug: _.trim(
                HelperFunctions.slugify(
                    _.truncate(area.title, {
                        length: 28,
                    }),
                ),
                '-',
            ),
        });

        return `${publicUrl}${path}?` + queryString.stringify(params);
    }, [publicUrl, areaId, block]);

    return (
        <FormModal show={true} onHide={handleClose} title={t('documents:document.editArea.tooltips.shareLink')}>
            <Modal.Body>
                <div className="border border-radius p-3 d-flex justify-content-between align-items-center">
                    <input className="flex-grow-1 mr-3" style={{ border: 'none' }} value={url} readOnly={true} />
                    <CopyToClipboard text={url} iconSize={18} />
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="btn btn-secondary" onClick={handleClose}>
                    {t('global:btn.close')}
                </Button>
            </Modal.Footer>
        </FormModal>
    );
}
